/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import Header from '../../View/Header/Header';
import Form from './Form';
import { getAbsencesData } from '../../apis/Network';
import LoadingIndicator from '../../View/LoadingIndicator';

export default class AbsenceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: '',
      absenceData: '',
      loading: true,
    };
    this.getAbsencesData = this.getAbsencesData.bind(this);
  }

  componentDidMount() {
    const result = JSON.parse(sessionStorage.getItem('data'));
    this.setState({ data: result });
    // eslint-disable-next-line prefer-destructuring
    const date = this.props.match.params.id;
    this.getAbsencesData(date);
  }

  getAbsencesData(date) {
    const userConfig = JSON.parse(sessionStorage.getItem('login_details'));
    const token = sessionStorage.getItem('token');
    const data = {
      token,
      student_id: userConfig.studentId,
      absence_date: date,
    };
    getAbsencesData(userConfig, data)
      .then(
        (response) => {
          if (response.status === 200) {
            console.log(response.data);
            this.setState({
              absenceData: response.data,
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
            });
            console.log(response.msg);
          }
        },
        (error) => {
          this.setState({
            loading: false,
          });
          console.log('bp12-performLogin', error);
        },
      )
      .catch((error) => {
        this.setState({
          loading: false,
        });
        console.log(error);
      });
  }

  render() {
    const { absenceData, loading } = this.state;
    return (
      <div>
        <Header data={this.state.data} />
        <div>
          <div>
            <div>
              <section className="content ca_box">
                <h2>
                  Absence Form
                  <Link to="/absenceform">
                    back
                    <FontAwesomeIcon icon={faArrowAltCircleRight} />
                  </Link>
                </h2>
                <div className="absence-detail">
                  {' '}
                  {
                    loading ? <LoadingIndicator />
                      : absenceData ? <Form absenceData={absenceData} />
                        : <p className="errorMsgAtFetch">Failed to fetch the details!</p>
                  }
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
